var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 44,
    viewBox: "0 0 152 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2898 27.406H50.1076V29.3639C50.1076 30.1006 50.0763 30.6157 50.0102 30.9772H49.4187V33.2011H50.6469V32.1062H53.6948V33.2011H54.923V30.9772H54.2828V27.4094L54.2898 27.406ZM53.0302 31.0045H51.2593C51.3219 30.5679 51.3567 30.0188 51.3567 29.4082V28.5009H53.0337V31.0045H53.0302ZM59.0634 27.406H60.3229V32.0994H59.0773V29.2036L57.115 32.0994H55.8554V27.406H57.101V30.3019L59.0634 27.406ZM64.091 30.6464C64.091 30.3496 63.8196 30.162 63.3568 30.162H62.7027V29.3025H63.3255C63.6943 29.3025 63.9483 29.1149 63.9483 28.8181C63.9483 28.5043 63.6769 28.3338 63.2142 28.3338C62.7201 28.3338 62.32 28.5521 62.066 28.9614L61.2205 28.3201C61.652 27.6926 62.3861 27.3344 63.2942 27.3344C64.4285 27.3344 65.1765 27.8836 65.1765 28.7124C65.1765 29.149 64.9678 29.4798 64.585 29.6811C65.0791 29.8687 65.3679 30.2609 65.3679 30.7623C65.3679 31.5912 64.4737 32.1881 63.2142 32.1881C62.24 32.1881 61.4432 31.7822 61.0605 31.0284L62.0347 30.4963C62.2748 30.9499 62.6888 31.1853 63.2316 31.1853C63.7744 31.1853 64.0945 30.9806 64.0945 30.6532L64.091 30.6464ZM69.0873 31.4274C69.1847 31.9118 69.5013 32.1301 70.0928 32.1301C70.3329 32.1301 70.4616 32.113 70.5555 32.0994V31.0181H70.3642C70.1902 31.0181 70.0928 30.9226 70.0928 30.7521V28.9068C70.0928 27.9211 69.3587 27.3276 68.1131 27.3276C67.2502 27.3276 66.5335 27.5936 65.9594 28.1257L66.7248 28.8932C67.0936 28.5316 67.539 28.344 68.033 28.344C68.5758 28.344 68.8959 28.5487 68.8959 28.8454C68.8959 29.1285 68.4645 29.207 67.9217 29.2684C67.0275 29.3775 65.862 29.5958 65.862 30.8169C65.862 31.6321 66.4847 32.1778 67.4276 32.1778C68.1305 32.1778 68.7533 31.8947 69.0873 31.4274ZM68.8646 30.2712C68.8646 30.7862 68.3531 31.1955 67.7164 31.1955C67.3163 31.1955 67.0936 31.0079 67.0936 30.6941C67.0936 30.2405 67.5564 30.162 68.0504 30.0836C68.4019 30.0222 68.6732 29.9744 68.8646 29.8653V30.2712ZM72.7753 32.0994H71.5158V27.406H72.7614V30.3019L74.7238 27.406H75.9833V32.0994H74.7377V29.2036L72.7753 32.0994ZM72.1386 25.7927L73.1128 25.6665C73.1755 26.011 73.4329 26.1815 73.753 26.1815C74.0731 26.1815 74.3271 26.011 74.3932 25.6665L75.3674 25.7927C75.2874 26.5295 74.682 26.966 73.7565 26.966C72.831 26.966 72.2256 26.5295 72.1456 25.7927H72.1386ZM80.4542 30.2712H78.5719V32.1028H77.295V27.4094H78.5719V29.1456H80.4542V27.4094H81.7311V32.1028H80.4542V30.2712ZM85.2104 32.1778C86.1359 32.1778 86.8387 31.864 87.3189 31.3626L86.536 30.6122C86.2333 30.9397 85.8019 31.1443 85.2278 31.1443C84.5424 31.1443 84.0936 30.7828 83.9683 30.1586H87.465C87.5137 29.9403 87.5137 29.8448 87.5137 29.7527C87.5137 28.2826 86.5882 27.3276 85.1339 27.3276C83.6795 27.3276 82.7088 28.3133 82.7088 29.7527C82.7088 31.1921 83.5543 32.1778 85.2139 32.1778H85.2104ZM85.1304 28.3304C85.7219 28.3304 86.1046 28.6578 86.2333 29.2547H83.9822C84.1249 28.6749 84.5424 28.3304 85.1304 28.3304ZM91.2296 27.3276C90.5755 27.3276 90.0466 27.5936 89.6813 28.0643L89.6187 27.406H88.4705V33.665H89.7474V31.5536C90.1162 31.9459 90.6103 32.1812 91.2331 32.1812C92.4474 32.1812 93.2755 31.2126 93.2755 29.7561C93.2755 28.2997 92.4787 27.331 91.2331 27.331L91.2296 27.3276ZM90.8295 31.1477C90.1128 31.1477 89.6952 30.6157 89.6952 29.7561C89.6952 28.8966 90.1093 28.3645 90.8295 28.3645C91.5497 28.3645 91.9777 28.8966 91.9777 29.7561C91.9777 30.6157 91.5462 31.1477 90.8295 31.1477ZM95.2204 29.7527C95.2204 30.6122 95.6657 31.1443 96.3686 31.1443C96.8626 31.1443 97.214 30.8783 97.3915 30.4076L98.6058 30.7691C98.3344 31.6628 97.4889 32.1778 96.386 32.1778C94.9003 32.1778 93.9122 31.2091 93.9122 29.7527C93.9122 28.2963 94.9003 27.3276 96.386 27.3276C97.4889 27.3276 98.3344 27.8426 98.6058 28.7363L97.3915 29.0978C97.2175 28.6271 96.8661 28.3611 96.3686 28.3611C95.6657 28.3611 95.2204 28.8932 95.2204 29.7527ZM101.814 29.0023H100.711V27.406H99.4338V32.0994H101.814C102.962 32.0994 103.665 31.5059 103.665 30.5508C103.665 29.5958 102.979 29.0023 101.814 29.0023ZM101.622 31.1307H100.711V29.9403H101.622C102.116 29.9403 102.374 30.145 102.374 30.5338C102.374 30.9226 102.12 31.1273 101.622 31.1273V31.1307ZM107.384 29.2513L109.346 32.0994H107.847L106.49 30.1108L105.867 30.7043V32.096H104.59V27.4026H105.867V29.282L107.687 27.4026H109.284L107.384 29.2479V29.2513ZM113.946 30.7555V28.9102C113.946 27.9245 113.212 27.331 111.966 27.331C111.103 27.331 110.387 27.597 109.813 28.1291L110.578 28.8966C110.947 28.535 111.392 28.3474 111.886 28.3474C112.429 28.3474 112.749 28.5521 112.749 28.8488C112.749 29.1319 112.318 29.2104 111.775 29.2718C110.881 29.3809 109.715 29.5992 109.715 30.8203C109.715 31.6355 110.338 32.1812 111.281 32.1812C111.984 32.1812 112.607 31.8981 112.941 31.4308C113.038 31.9152 113.355 32.1335 113.946 32.1335C114.186 32.1335 114.315 32.1164 114.409 32.1028V31.0215H114.217C114.043 31.0215 113.946 30.926 113.946 30.7555ZM112.714 30.2712C112.714 30.7862 112.203 31.1955 111.566 31.1955C111.166 31.1955 110.943 31.0079 110.943 30.6941C110.943 30.2405 111.406 30.162 111.9 30.0836C112.252 30.0222 112.523 29.9744 112.714 29.8653V30.2712ZM121.799 30.7555V28.9102C121.799 27.9245 121.065 27.331 119.819 27.331C118.956 27.331 118.24 27.597 117.665 28.1291L118.431 28.8966C118.8 28.535 119.245 28.3474 119.739 28.3474C120.282 28.3474 120.602 28.5521 120.602 28.8488C120.602 29.1319 120.171 29.2104 119.628 29.2718C118.734 29.3809 117.568 29.5992 117.568 30.8203C117.568 31.6355 118.191 32.1812 119.134 32.1812C119.837 32.1812 120.459 31.8981 120.793 31.4308C120.891 31.9152 121.207 32.1335 121.799 32.1335C122.039 32.1335 122.168 32.1164 122.262 32.1028V31.0215H122.07C121.896 31.0215 121.799 30.926 121.799 30.7555ZM120.571 30.2712C120.571 30.7862 120.059 31.1955 119.422 31.1955C119.022 31.1955 118.8 31.0079 118.8 30.6941C118.8 30.2405 119.262 30.162 119.757 30.0836C120.108 30.0222 120.379 29.9744 120.571 29.8653V30.2712ZM123.218 27.406H126.858V28.5657H124.495V32.1028H123.218V27.4094V27.406ZM129.446 27.3276C127.978 27.3276 127.021 28.3133 127.021 29.7527C127.021 31.1921 127.867 32.1778 129.526 32.1778C130.452 32.1778 131.155 31.864 131.635 31.3626L130.852 30.6122C130.549 30.9397 130.118 31.1443 129.544 31.1443C128.858 31.1443 128.41 30.7828 128.284 30.1586H131.781C131.83 29.9403 131.83 29.8448 131.83 29.7527C131.83 28.2826 130.904 27.3276 129.45 27.3276H129.446ZM128.295 29.2513C128.437 28.6715 128.855 28.327 129.443 28.327C130.031 28.327 130.417 28.6544 130.546 29.2513H128.295ZM135.942 27.406H137.219V32.0994H135.942V30.2677H134.06V32.0994H132.783V27.406H134.06V29.1422H135.942V27.406ZM142.936 30.9738H143.576V33.1977H142.348V32.1028H138.531V27.4094H139.808V30.9772H141.659V27.4094H142.936V30.9772V30.9738ZM144.529 25.7484H145.904V26.8126H144.529V25.7484ZM144.578 27.406H145.855V32.0994H144.578V27.406ZM148.938 27.406C147.755 27.406 147.006 28.0166 147.006 28.9853C147.006 29.6265 147.34 30.0801 147.901 30.3155L146.735 32.0994H148.141L149.129 30.5031H149.992V32.0994H151.251V27.406H148.938ZM149.992 29.5822H149.098C148.586 29.5822 148.301 29.3775 148.301 29.0023C148.301 28.6271 148.59 28.4088 149.098 28.4088H149.992V29.5822ZM52.5988 37.584C51.9447 37.584 51.4158 37.8501 51.0505 38.3208L50.9879 37.6625H49.8397V43.9214H51.1166V41.8101C51.4854 42.2023 51.9795 42.4377 52.6023 42.4377C53.8166 42.4377 54.6447 41.469 54.6447 40.0126C54.6447 38.5561 53.8479 37.5874 52.6023 37.5874L52.5988 37.584ZM52.1987 41.4008C51.482 41.4008 51.0644 40.8687 51.0644 40.0091C51.0644 39.1496 51.4785 38.6175 52.1987 38.6175C52.9189 38.6175 53.3469 39.1496 53.3469 40.0091C53.3469 40.8687 52.9154 41.4008 52.1987 41.4008ZM57.7064 37.584C56.2382 37.584 55.2814 38.5698 55.2814 40.0091C55.2814 41.4485 56.1268 42.4343 57.7865 42.4343C58.712 42.4343 59.4148 42.1205 59.8949 41.6191L59.1121 40.8687C58.8094 41.1961 58.3779 41.4008 57.8039 41.4008C57.1184 41.4008 56.6696 41.0392 56.5444 40.415H60.0411C60.0898 40.1967 60.0898 40.1012 60.0898 40.0091C60.0898 38.5391 59.1643 37.584 57.7099 37.584H57.7064ZM56.5583 39.5077C56.7009 38.9279 57.1184 38.5834 57.7064 38.5834C58.2944 38.5834 58.6807 38.9108 58.8094 39.5077H56.5583ZM65.2879 37.6625H67.1389V42.3558H65.9107V39.1019L64.7138 42.3558H63.4682L62.2713 39.1019V42.3558H61.0431V37.6625H62.9115L64.1084 40.9028L65.2913 37.6625H65.2879ZM70.6216 37.584C69.1221 37.584 68.1166 38.5527 68.1166 40.0091C68.1166 41.4656 69.1047 42.4343 70.6216 42.4343C72.1386 42.4343 73.1268 41.4656 73.1268 40.0091C73.1268 38.5527 72.1386 37.584 70.6216 37.584ZM70.6216 41.4008C69.8875 41.4008 69.4248 40.8857 69.4248 40.0091C69.4248 39.1326 69.8875 38.6175 70.6216 38.6175C71.3558 38.6175 71.8185 39.1326 71.8185 40.0091C71.8185 40.8857 71.3558 41.4008 70.6216 41.4008ZM77.2602 37.6625H78.5371V42.3558H77.2602V40.5242H75.3779V42.3558H74.101V37.6625H75.3779V39.3986H77.2602V37.6625ZM79.3512 37.6625H83.9474V38.7881H82.2878V42.3558H81.0109V38.7881H79.3512V37.6625ZM88.1469 37.6625H89.4865L87.8269 42.3558C87.4441 43.42 86.8213 43.9998 85.9445 43.9998C84.7616 43.9998 84.3649 43.2324 84.3162 42.5127L85.5131 42.3081C85.5305 42.6833 85.6558 42.9186 85.9759 42.9186C86.1672 42.9186 86.3099 42.8095 86.456 42.5912L84.2049 37.6625H85.6105L87.0649 41.1995L88.1504 37.6625H88.1469Z",
    fill: "#201628"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4877 4.58768C67.6782 6.37928 68.284 8.53214 68.284 10.9846C68.284 13.0993 67.8042 15.0025 66.8566 16.6355C65.9029 18.2832 64.6434 19.5167 63.111 20.3009C61.5995 21.0763 59.4883 21.4699 56.8313 21.4699H49.5861V11.4163H53.0198V18.1216H54.6392C57.3741 18.1216 59.2784 17.9601 60.304 17.6429C61.6685 17.2111 62.7601 16.4181 63.5428 15.2844C64.3375 14.139 64.7394 12.6998 64.7394 11.011C64.7394 9.23116 64.3015 7.70095 63.4408 6.46152C62.5922 5.2397 61.3806 4.3909 59.8452 3.93859C58.6307 3.57439 56.5734 3.38936 53.7275 3.38936H49.5831V0H54.5522C57.728 0 59.9921 0.252587 61.4736 0.772445C63.5938 1.4979 65.2822 2.78139 66.4847 4.59062L66.4877 4.58768ZM107.422 2.30265C106.589 1.31286 105.491 0.643215 104.166 0.320139C103.29 0.105734 101.682 0 99.2564 0H94.4522V3.38936H100.843C102.123 3.38936 103.035 3.48922 103.551 3.68894C104.016 3.8681 104.384 4.16768 104.672 4.59943C104.966 5.04292 105.11 5.52166 105.11 6.06795C105.11 6.61425 104.966 7.08417 104.669 7.53354C104.381 7.97116 103.995 8.27662 103.488 8.47046C102.93 8.68487 101.991 8.79354 100.702 8.79354H94.4492V21.4728H97.9639V12.1535H98.6896C101.308 12.1535 103.065 12.0419 104.061 11.8099C105.485 11.4751 106.625 10.8054 107.446 9.81563C108.274 8.81997 108.694 7.55998 108.694 6.07089C108.694 4.5818 108.265 3.30419 107.422 2.30265ZM80.1656 0L90.3827 21.4728H86.5831L83.3714 14.8674H71.5618L78.7381 0H80.1716H80.1656ZM79.4428 6.65243L77.0857 11.5074H81.764L79.4428 6.65243Z",
    fill: "#201628"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_631_25573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 44
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1499 5.00723C41.9578 11.6835 40.1668 8.64539 40.1668 22C40.1668 35.3546 41.9578 32.3165 30.1499 38.9928C18.3419 45.6691 21.9239 45.6691 10.114 38.9928C-1.69398 32.3165 0.0970225 35.3546 0.0970225 22C0.0970225 8.64539 -1.69398 11.6835 10.114 5.00723C21.9219 -1.66908 18.3399 -1.66908 30.1499 5.00723Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_631_25573)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9578 -1.66895H-1.69396V45.6712H41.9578V-1.66895Z",
    fill: "url(#paint0_linear_631_25573)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8871 6.95508L20.1493 8.60515L30.252 14.7214L27.8871 6.95508Z",
    fill: "#D1D3D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5849 0.0571289L25.8286 0.189135L26.7455 3.20127L30.5849 0.0571289Z",
    fill: "#414042"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0493 -2.40918L12.8158 0.552955L12.9873 0.548955L14.4332 -2.40918H11.0493Z",
    fill: "#D1D3D4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4834 4.90725L34.1709 2.57715L27.4379 5.47328L27.8871 6.95535L37.4834 4.90725Z",
    fill: "#939598"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8955 -2.40918L3.46868 7.18326L12.8158 0.552955L4.17324 -2.40918H3.8955Z",
    fill: "#6D6E71"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1644 38.3345L0.595322 42.3387L6.52584 40.4206L3.1644 38.3345Z",
    fill: "#58595B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.05814 -2.40918L-0.895467 1.14698L0.58512 -2.40918H-3.05814Z",
    fill: "#E6E7E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61709 26.2363L2.61505 26.3083L2.59055 26.2763L1.24066 37.1408L3.1644 38.3349L10.3733 27.1044L2.61709 26.2363Z",
    fill: "#414042"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8382 30.7724L12.8158 30.7164L11.0044 25.9102L10.3733 27.1042L15.393 37.5507L12.8382 30.7724Z",
    fill: "#58595B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4717 8.51539L37.4834 4.90723L42.0109 17.2618L44.4717 8.51539Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6917 -0.225098L34.1709 2.57703L37.4834 4.90714L40.6917 -0.225098Z",
    fill: "#414042"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8382 30.7725L15.393 37.5508L21.8014 34.2446L12.8382 30.7725Z",
    fill: "#6D6E71"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8158 30.7164L12.8382 30.7724L12.873 30.6924L12.8158 30.7164Z",
    fill: "#BCBEC0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3216 18.2658L15.1132 18.1338L11.0044 25.9101L12.8158 30.7164L15.3216 18.2658Z",
    fill: "#A7A9AC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8197 27.6162L34.0464 27.9262L34.2404 27.8262L34.2118 27.7342L33.8197 27.6162Z",
    fill: "#414042"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52584 40.4209L0.595322 42.339L9.84235 44.1511L10.7654 43.053L6.52584 40.4209Z",
    fill: "#A7A9AC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6878 -2.40918L12.8158 0.552955L11.0493 -2.40918H10.6878Z",
    fill: "#BCBEC0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17324 -2.40918L12.8158 0.552955L10.6878 -2.40918H4.17324Z",
    fill: "#E6E7E8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84236 44.1508L13.7777 44.9208L10.7654 43.0527L9.84236 44.1508Z",
    fill: "#D1D3D4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.252 14.7217L32.3718 16.0057L37.4834 4.90723L27.8871 6.95532L30.252 14.7217Z",
    fill: "#939598"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4332 -2.40918L12.9873 0.548955L22.9634 0.268942L23.8681 -2.40918H14.4332Z",
    fill: "#E6E7E8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7455 3.2011L25.8286 0.188965L22.9634 0.268969L20.1493 8.60535L26.7455 3.2011Z",
    fill: "#58595B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4378 5.47314L20.1493 8.60529L27.8871 6.95521L27.4378 5.47314Z",
    fill: "#F1F2F2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3718 16.0057L30.252 14.7217L30.6155 15.9197L32.3534 16.0297L32.3718 16.0057Z",
    fill: "#58595B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3216 18.2659L17.6374 19.736L19.602 15.2198L20.1493 8.88748L20.3413 9.15149L20.1493 8.60547L15.2623 17.8539L15.1132 18.1339L15.3216 18.2659Z",
    fill: "#D1D3D4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5126 19.0279L42.0109 17.2618L37.4834 4.90723L32.3718 16.0057L41.5126 19.0279Z",
    fill: "#939598"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4657 16.0379L34.3833 27.7464L40.8469 21.3941L41.5126 19.028L32.3718 16.0059L32.3534 16.0299L32.4657 16.0379Z",
    fill: "#A7A9AC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2404 27.8264L34.3425 27.7744L34.2118 27.7344L34.2404 27.8264Z",
    fill: "#6D6E71"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M12.873 30.6922L17.6374 19.7357L15.3216 18.2656L12.8158 30.7162L12.873 30.6922Z",
    fill: "#F1F2F2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4378 5.47337L34.1709 2.57724L30.5849 0.0571289L26.7455 3.20127L27.4378 5.47337Z",
    fill: "#A7A9AC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6917 -0.225098L30.5849 0.0569151L34.171 2.57703L40.6917 -0.225098Z",
    fill: "#414042"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7455 3.20117L20.1493 8.60542L27.4378 5.47328L26.7455 3.20117Z",
    fill: "#808285"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57216 26.25L-2.60274 29.7122L-1.08744 35.6964L1.24066 37.1405L2.59055 26.276L2.57216 26.25Z",
    fill: "#939598"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0383 -2.40918L25.8286 0.188938L30.5849 0.0569324L27.0784 -2.40918H25.0383Z",
    fill: "#E6E7E8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46458 12.6474V12.6494L14.1943 10.3653L12.8382 0.856842L12.9873 0.548828L12.8158 0.552828L6.26853 12.5254L6.46458 12.6474Z",
    fill: "#808285"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6171 26.2359L10.3733 27.1039L11.0044 25.9099L6.26649 13.3413L2.62118 26.1399L2.6171 26.2359Z",
    fill: "#58595B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2623 17.8536L14.1943 10.3652L6.46458 12.6493L15.1133 18.1336L15.2623 17.8536Z",
    fill: "#A7A9AC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2928 35.0845L46.5936 40.5987L51.311 35.3545L45.7052 32.1104L39.2928 35.0845Z",
    fill: "#808285"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24065 37.1406L0.595322 42.3389L3.1644 38.3347L1.24065 37.1406Z",
    fill: "#E6E7E8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87847 12.3097L5.86213 12.2677L3.41968 8.24951L3.30531 10.8256L5.87847 12.3097Z",
    fill: "#BCBEC0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41967 8.24908L5.86213 12.2673L6.26852 12.5253L12.8158 0.552734L3.46868 7.18303L3.41967 8.24908Z",
    fill: "#E6E7E8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29373 46.155L7.75932 45.303L0.595322 42.3389V46.155H4.29373Z",
    fill: "#231F20"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46458 12.6474L6.26852 12.5254L6.26444 12.5334L6.46458 12.6474Z",
    fill: "#939598"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0784 -2.40918L30.5849 0.0569324L31.949 -2.40918H27.0784Z",
    fill: "#58595B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4834 4.90734L44.4717 8.51551L45.8666 3.55928L43.9265 -0.316895L40.6917 -0.22489L37.4834 4.90734Z",
    fill: "#414042"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4303 28.4522L34.2404 27.8262L34.0464 27.9262L34.4303 28.4522Z",
    fill: "#E6E7E8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6318 36.3687L36.8115 36.2807L36.7319 36.0146L36.6318 36.3687Z",
    fill: "#939598"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3228 38.3208L21.8014 34.2446L15.393 37.5508L32.3718 38.4228L32.3228 38.3208Z",
    fill: "#6D6E71"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0044 25.91L15.1132 18.1337L6.46458 12.6494L6.26648 13.3414L11.0044 25.91Z",
    fill: "#F1F2F2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4657 38.3769L32.3228 38.3209L32.3718 38.4229L36.6318 36.3688L36.7319 36.0148L36.1355 34.0547L32.4657 38.3769Z",
    fill: "#231F20"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8948 12.3196L5.86212 12.2676L5.87846 12.3096L5.8948 12.3196Z",
    fill: "#808285"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26443 12.5336L6.26852 12.5256L5.86212 12.2676L5.8948 12.3196L6.26443 12.5336Z",
    fill: "#F1F2F2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2866 35.0885L39.2805 35.0985L39.2764 35.0925L36.8115 36.2805L37.7121 39.2387L46.5936 40.5987L39.2928 35.0845L39.2866 35.0885Z",
    fill: "#231F20"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7654 43.053L15.393 37.5508L6.52583 40.4209L10.7654 43.053Z",
    fill: "#D1D3D4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84235 44.1509L0.595322 42.3389L7.75932 45.303L9.03773 44.989L8.00234 45.403L9.1378 45.873L9.03364 45.111L9.84235 44.1509Z",
    fill: "#939598"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8769 46.1552L35.4494 40.569L32.3718 38.4229V46.1552H33.8769Z",
    fill: "#BCBEC0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0477 46.1551L38.8374 42.933L35.4494 40.5688L33.8769 46.1551H39.0477Z",
    fill: "#E6E7E8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8373 42.9329L46.5936 40.5988L37.7121 39.2388L38.8373 42.9329Z",
    fill: "#A7A9AC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3718 46.1552V38.4228L15.393 37.5508L31.0015 46.1552H32.3718Z",
    fill: "#BCBEC0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M15.393 37.5508L10.7654 43.053L13.7776 44.9211L18.3726 45.8212L15.393 37.5508Z",
    fill: "#58595B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7708 46.1552H31.0015L15.393 37.5508L18.3726 45.8212L18.7708 46.1552Z",
    fill: "#58595B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6086 46.1549L46.5936 40.5986L38.8373 42.9327L39.0477 46.1549H41.6086Z",
    fill: "#BCBEC0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8681 -2.40918L22.9634 0.268942L25.8286 0.188938L25.0383 -2.40918H23.8681Z",
    fill: "#808285"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1943 10.3655L20.1493 8.60542L22.9634 0.269043L12.9873 0.549056L12.8382 0.85707L14.1943 10.3655Z",
    fill: "#6D6E71"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3956 33.6546L39.2478 35.0506L37.6263 32.8325L37.3956 33.6546Z",
    fill: "#414042"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4827 26.2403L44.0429 24.8362L42.8155 19.46L40.8468 21.394L39.4827 26.2403Z",
    fill: "#414042"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1493 8.60547L14.1943 10.3655L15.2623 17.8539L20.1493 8.60547Z",
    fill: "#6D6E71"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6147 29.9604L39.2887 35.0827L39.2928 35.0847L45.7052 32.1105L45.4786 31.1205L41.6147 29.9604Z",
    fill: "#E6E7E8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0177 29.4781L38.6842 29.0781L37.853 32.0283L40.0177 29.4781Z",
    fill: "#A7A9AC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1355 34.0545L36.7319 36.0146L37.3956 33.6545L36.834 33.2305L36.1355 34.0545Z",
    fill: "#808285"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3895 27.7883L34.4242 27.7983L39.4827 26.2403L40.8469 21.394L34.3833 27.7463L34.3895 27.7883Z",
    fill: "#939598"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9027 38.9628L36.6318 36.3687L32.3718 38.4227L35.9027 38.9628Z",
    fill: "#6D6E71"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M37.416 32.5425L36.834 33.2305L37.3956 33.6545L37.6263 32.8325L37.416 32.5425Z",
    fill: "#808285"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2866 35.0885L39.2928 35.0845L39.2887 35.0825L39.2866 35.0885Z",
    fill: "#A7A9AC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3936 27.8084L34.3895 27.7884L34.3425 27.7744L34.2404 27.8264L34.4303 28.4524L37.416 32.5426L37.853 32.0286L38.6842 29.0785L34.4242 27.7984L34.3936 27.8084Z",
    fill: "#808285"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3956 33.6543L36.7319 36.0144L36.8115 36.2804L39.2764 35.0924L39.2478 35.0504L37.3956 33.6543Z",
    fill: "#808285"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9027 38.9629L37.7121 39.2389L36.8115 36.2808L36.6318 36.3688L35.9027 38.9629Z",
    fill: "#58595B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4493 40.569L38.8373 42.9331L37.7121 39.2389L35.9027 38.9629L35.4493 40.569Z",
    fill: "#231F20"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4494 40.569L35.9027 38.9629L32.3718 38.4229L35.4494 40.569Z",
    fill: "#D1D3D4"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9491 -2.40918L30.5849 0.0569324L40.6917 -0.22508L40.3404 -2.40918H31.9491Z",
    fill: "#414042"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.51353 32.3286L-5.39237 42.3391H0.595324L-1.08744 35.6968L-6.51353 32.3286Z",
    fill: "#414042"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.08744 35.6968L0.595324 42.3391L1.24066 37.1408L-1.08744 35.6968Z",
    fill: "#E6E7E8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26648 13.3414L6.04592 12.7534L3.2032 13.0954L2.62117 26.14L6.26648 13.3414Z",
    fill: "#A7A9AC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57216 26.2503L-6.47269 14.3137L-6.48291 14.2617L-6.51558 14.2657L-2.60275 29.7124L2.57216 26.2503Z",
    fill: "#BCBEC0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87847 12.3093L3.30531 10.8252L3.2032 13.0953L6.04593 12.7533L5.87847 12.3093Z",
    fill: "#939598"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0.595317 46.155V42.3389H-5.39238L-4.96352 46.155H0.595317Z",
    fill: "#E6E7E8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15008 12.7417L6.46458 12.6497V12.6477L6.26444 12.5337L6.15008 12.7417Z",
    fill: "#F1F2F2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26444 12.5333L5.8948 12.3193L6.15008 12.7414L6.26444 12.5333Z",
    fill: "#D1D3D4"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04593 12.7534L6.26648 13.3414L6.46457 12.6494L6.15008 12.7414L6.04593 12.7534Z",
    fill: "#808285"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15007 12.7416L5.8948 12.3196L5.87846 12.3096L6.04592 12.7536L6.15007 12.7416Z",
    fill: "#6D6E71"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59055 26.2759L2.61505 26.3079L2.61709 26.2359L2.59463 26.2339L2.59055 26.2759Z",
    fill: "#D1D3D4"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0.585109 -2.40918L-0.895477 1.14698L2.98264 7.52927L3.46868 7.18326L3.8955 -2.40918H0.585109Z",
    fill: "#A7A9AC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.51488 4.02689L-8.34742 4.0969L0.564689 9.24313L2.98264 7.52905L-0.895478 1.14676L-0.940407 1.25477L-13.4651 -0.965332L-13.5999 -0.893329L-8.54552 3.86689L-8.51488 4.02689Z",
    fill: "#414042"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0.564695 9.2434L-8.34742 4.09717L-8.47403 4.23317L-6.48494 14.2436L0.564695 9.2434Z",
    fill: "#D1D3D4"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57216 26.2499L2.59054 26.2759L2.59462 26.2339L2.57216 26.2499Z",
    fill: "#939598"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41968 8.24933L2.98265 7.5293L0.564697 9.24337L3.30531 10.8254L3.41968 8.24933Z",
    fill: "#6D6E71"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59462 26.2341L2.61708 26.2361L2.62117 26.1401L2.59462 26.2341Z",
    fill: "#58595B"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46868 7.18311L2.98264 7.52912L3.41967 8.24915L3.46868 7.18311Z",
    fill: "#58595B"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57217 26.2503L2.59463 26.2343L2.62118 26.1403L3.2032 13.0957L-6.4829 14.2618L-6.47269 14.3138L2.57217 26.2503Z",
    fill: "#414042"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.4829 14.2614L3.2032 13.0953L3.30531 10.8252L0.564693 9.24316L-6.48494 14.2434L-6.4829 14.2614Z",
    fill: "#231F20"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2118 27.7342L31.1567 17.6997L28.8898 20.8619L33.8197 27.6162L34.2118 27.7342Z",
    fill: "#D1D3D4"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3534 16.0294L30.6155 15.9194L31.1567 17.6995L32.3534 16.0294Z",
    fill: "#58595B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3425 27.7743L34.3711 27.7583L34.3833 27.7463L32.4657 16.0378L32.3534 16.0298L31.1567 17.6999L34.2118 27.7343L34.3425 27.7743Z",
    fill: "#E6E7E8"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6842 29.0781L40.0177 29.4781L43.9265 24.8719L41.6147 29.9602L45.4786 31.1202L44.0429 24.8359L39.4827 26.24L38.6842 29.0781Z",
    fill: "#A7A9AC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3425 27.7741L34.3895 27.7881L34.3833 27.7461L34.3711 27.7581L34.3425 27.7741Z",
    fill: "#58595B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6842 29.0784L39.4827 26.2402L34.4242 27.7983L38.6842 29.0784Z",
    fill: "#A7A9AC"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4242 27.7981L34.3895 27.7881L34.3935 27.8081L34.4242 27.7981Z",
    fill: "#E6E7E8"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8197 27.6163L26.478 25.4102L31.5304 29.2243L34.0464 27.9263L33.8197 27.6163Z",
    fill: "#D1D3D4"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0675 25.286L25.7265 25.184L25.6775 25.104L12.873 30.6923L12.8382 30.7723L21.8014 34.2444L28.6673 30.7023L26.0675 25.286Z",
    fill: "#BCBEC0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0676 25.2861L28.6673 30.7024L31.5304 29.2243L26.478 25.4101L26.0676 25.2861Z",
    fill: "#414042"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M19.602 15.2197L17.6374 19.7359L25.4059 24.6642L19.602 15.2197Z",
    fill: "#BCBEC0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3412 9.15122L20.1493 8.88721L19.602 15.2195L22.5468 15.4075L20.3412 9.15122Z",
    fill: "#BCBEC0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6775 25.1041L25.4059 24.6641L17.6374 19.7358L12.873 30.6923L25.6775 25.1041Z",
    fill: "#E6E7E8"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5304 29.2241L28.6673 30.7022L32.3228 38.3205L32.4657 38.3765L36.1355 34.0543L35.6005 32.2983L31.5304 29.2241Z",
    fill: "#939598"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8014 34.2443L32.3228 38.3205L28.6672 30.7021L21.8014 34.2443Z",
    fill: "#BCBEC0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5304 29.2243L35.6005 32.2985L34.4303 28.4523L34.0464 27.9263L31.5304 29.2243Z",
    fill: "#D1D3D4"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2805 35.0984L39.2866 35.0884L39.2764 35.0924L39.2805 35.0984Z",
    fill: "#808285"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M37.853 32.0281L37.6263 32.8322L39.2478 35.0503L39.2887 35.0823L41.6147 29.9601L40.0177 29.478L37.853 32.0281Z",
    fill: "#808285"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6263 32.8324L37.853 32.0283L37.416 32.5423L37.6263 32.8324Z",
    fill: "#BCBEC0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6005 32.2983L36.834 33.2304L37.416 32.5423L34.4303 28.4521L35.6005 32.2983Z",
    fill: "#A7A9AC"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1355 34.0544L36.834 33.2304L35.6005 32.2983L36.1355 34.0544Z",
    fill: "#A7A9AC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2478 35.0503L39.2764 35.0923L39.2866 35.0883L39.2887 35.0823L39.2478 35.0503Z",
    fill: "#D1D3D4"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7143 15.4175L25.9266 24.5299L28.7224 20.6317L25.024 15.5655L22.7143 15.4175Z",
    fill: "#6D6E71"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3412 9.15149L24.6666 15.0778L25.024 15.5658L25.3793 15.5878L30.6155 15.9198L30.252 14.7217L20.1493 8.60547L20.3412 9.15149Z",
    fill: "#A7A9AC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7224 20.6317L28.8898 20.8617L31.1567 17.6995L30.6155 15.9194L25.3793 15.5874L25.024 15.5654L28.7224 20.6317Z",
    fill: "#BCBEC0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5468 15.4077L22.7143 15.4177L25.024 15.5657L24.6666 15.0776L20.3412 9.15137L22.5468 15.4077Z",
    fill: "#58595B"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M26.478 25.4102L25.9266 24.9941L26.0675 25.2862L26.478 25.4102Z",
    fill: "#F1F2F2"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0676 25.2862L25.9266 24.9941L25.6775 25.1041L25.7265 25.1842L26.0676 25.2862Z",
    fill: "#A7A9AC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9266 24.9942L22.5468 15.4077L19.602 15.2197L25.4059 24.6642L25.9266 24.9942Z",
    fill: "#E6E7E8"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4059 24.6641L25.6775 25.1041L25.9266 24.9941L25.4059 24.6641Z",
    fill: "#A7A9AC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0177 29.4783L41.6147 29.9603L43.9265 24.8721L40.0177 29.4783Z",
    fill: "#D1D3D4"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9266 24.994L28.8898 20.8618L28.7224 20.6318L25.8184 24.682L25.9266 24.994Z",
    fill: "#A7A9AC"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M26.478 25.41L33.8197 27.6161L28.8898 20.8618L25.9266 24.994L26.478 25.41Z",
    fill: "#939598"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8184 24.6821L25.9552 24.4921L22.7122 15.4077H22.5468",
    fill: "#808285"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.209305 9.35512L1.47754 16.9355L7.72256 7.04102L-0.209305 9.35512Z",
    fill: "#6D6E71"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.7443 24.1162L-9.86476 32.8506L0.0255594 33.2726L-6.7443 24.1162Z",
    fill: "#D1D3D4"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8326 33.5685L35.9211 36.0866L33.9606 30.2783L31.8326 33.5685Z",
    fill: "#808285"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4794 34.1046L19.553 34.1086L19.5182 34.1326L30.6135 35.4547L31.8326 33.5686L20.3658 26.5103L19.4794 34.1046Z",
    fill: "#BCBEC0"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1111 24.0959L24.0519 24.1159L19.1445 25.8919L20.3658 26.51L31.0321 21.5938L24.1111 24.0959Z",
    fill: "#414042"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1111 24.0958L31.0321 21.5937L27.6564 15.3174L24.1111 24.0958Z",
    fill: "#A7A9AC"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0519 24.116L24.1111 24.096L24.0274 24.062L24.0519 24.116Z",
    fill: "#BCBEC0"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3413 21.6641L11.2065 21.8681L19.1445 25.8923L24.0519 24.1162L11.3413 21.6641Z",
    fill: "#E6E7E8"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8885 3.54727L21.203 3.32526L21.1009 3.13525L21.007 3.16326L20.8885 3.54727Z",
    fill: "#808285"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9606 30.2782L35.9211 36.0864L37.7693 27.03L36.6481 26.126L33.9606 30.2782Z",
    fill: "#58595B"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7693 27.03L38.5576 23.1738L36.6481 26.126L37.7693 27.03Z",
    fill: "#414042"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4909 18.7278H39.5011L39.4766 18.6758L38.5576 23.174L40.3159 20.4559L39.5092 18.7438L39.4909 18.7278Z",
    fill: "#BCBEC0"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72256 7.04131L9.03365 4.96521L-2.3005 -0.0410156L-0.209298 9.35541L7.72256 7.04131Z",
    fill: "#A7A9AC"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.04045 10.4756L-7.11599 11.3716L-7.0343 14.1798L1.47754 16.9359L-4.04045 10.4756Z",
    fill: "#808285"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.72051 9.79749L1.47755 16.9358L-0.209293 9.35547L-1.72051 9.79749Z",
    fill: "#6D6E71"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03365 4.96533L7.72256 7.04143L8.94584 6.68341L9.05816 4.98133L9.03365 4.96533Z",
    fill: "#939598"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3413 21.6638L12.8423 19.3937L8.23107 17.4716L1.7655 16.9356L2.03507 16.7456L1.47755 16.9356L10.9186 21.7218L11.2065 21.8678L11.3413 21.6638Z",
    fill: "#58595B"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43872 -2.40918L-2.3005 -0.0410719L9.03365 4.96516L11.5762 -2.40918H4.43872Z",
    fill: "#6D6E71"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05816 4.98105L9.06428 4.87305L9.03365 4.96505L9.05816 4.98105Z",
    fill: "#808285"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4829 -2.40918H11.5762L9.06429 4.87115L21.0213 2.99507L15.4829 -2.40918Z",
    fill: "#58595B"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1009 3.13516L21.0478 3.03516L21.007 3.16316L21.1009 3.13516Z",
    fill: "#A7A9AC"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0274 24.0623L12.8423 19.394L11.3413 21.6641L24.0519 24.1163L24.0274 24.0623Z",
    fill: "#231F20"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.04045 10.4754L1.47754 16.9357L-1.72053 9.79736L-4.04045 10.4754Z",
    fill: "#414042"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6979 43.0491H25.7L29.139 37.7349L23.0267 39.2189L25.6979 43.0491Z",
    fill: "#808285"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04662 46.1551L7.2549 43.051L7.23448 43.021L-2.98872 44.9671L-1.647 46.1551H4.04662Z",
    fill: "#BCBEC0"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39716 46.1549L7.2549 43.0508L4.04662 46.1549H9.39716Z",
    fill: "#939598"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4937 34.1503L23.0267 39.2186L29.139 37.7345L30.6135 35.4544L19.5182 34.1323L19.4937 34.1503Z",
    fill: "#BCBEC0"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60481 30.3384L3.27468 22.7681L-6.43593 24.0961L-6.75043 23.9481L-6.7443 24.1161L5.4782 30.5304L5.60481 30.3384Z",
    fill: "#E6E7E8"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9186 21.7217L3.27467 22.7677L5.60481 30.3381L11.2065 21.8677L10.9186 21.7217Z",
    fill: "#D1D3D4"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8326 33.5683L33.9606 30.2781L31.0321 21.5938L20.3658 26.51L31.8326 33.5683Z",
    fill: "#939598"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6135 35.4544L35.9211 36.0865L31.8327 33.5684L30.6135 35.4544Z",
    fill: "#939598"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25968 30.9121L5.21476 30.9281L1.112 33.3182L3.74234 33.4322L5.25968 30.9121Z",
    fill: "#58595B"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5296 27.7201L39.0497 28.8322L42.0803 36.0865H47.6106H47.6984L43.5037 27.2041L39.5296 27.7201Z",
    fill: "#6D6E71"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1.112 33.3186L5.21475 30.9285L5.4782 30.5305L-6.7443 24.1162L0.0255527 33.2726L1.112 33.3186Z",
    fill: "#6D6E71"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9476 29.0703L35.9211 36.0866H40.7448L38.9476 29.0703Z",
    fill: "#231F20"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60481 30.3384L5.4782 30.5304L5.48637 30.5344L5.60481 30.3384Z",
    fill: "#A7A9AC"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7401 2.94922L21.1009 3.13523L21.2031 3.32524L21.7401 2.94922Z",
    fill: "#BCBEC0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8231 0.792754L29.7353 0.614746L29.4637 0.69475L29.8231 0.792754Z",
    fill: "#414042"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8163 5.01333L27.6564 15.3178L31.0321 21.5941L31.9205 4.96533L31.8163 5.01333Z",
    fill: "#BCBEC0"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1445 25.8923L11.2065 21.8682L5.60482 30.3385L6.31142 30.5326L19.1445 25.8923Z",
    fill: "#D1D3D4"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8735 4.87101L31.8163 5.01302L31.9205 4.96502L29.8231 0.792829L29.4637 0.694824L27.4603 1.27885L31.8735 4.87101Z",
    fill: "#F1F2F2"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26989 30.8965L5.21475 30.9285L5.25968 30.9125L5.26989 30.8965Z",
    fill: "#414042"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48636 30.5343L5.47819 30.5303L5.21475 30.9283L5.26989 30.8963L5.48636 30.5343Z",
    fill: "#BCBEC0"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9838 -2.40918L28.5141 -1.81315L28.5161 -1.80715L28.5284 -1.80315L28.5222 -1.79715L29.7353 0.614958L32.7557 -0.267082L33.0968 -2.40918H28.9838Z",
    fill: "#F1F2F2"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6481 26.126L31.0321 21.5938L33.9606 30.2781L36.6481 26.126Z",
    fill: "#58595B"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7693 27.0303L35.9211 36.0867L38.9476 29.0704L38.627 27.8183L39.0497 28.8324L39.5297 27.7203L38.7495 27.8203L37.7693 27.0303Z",
    fill: "#58595B"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5875 4.96531L44.4289 4.7353L40.9796 3.80526L40.6753 4.8713L40.9204 3.78926L34.1138 1.95117L31.9205 4.96531H40.5875Z",
    fill: "#E6E7E8"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9204 3.78906L42.1682 -1.72119L36.5276 -1.36718L34.1138 1.95097L40.9204 3.78906Z",
    fill: "#E6E7E8"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9204 4.96533L31.0321 21.5941L40.5875 4.96533H31.9204Z",
    fill: "#F1F2F2"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5296 27.72L43.5037 27.2039L41.5432 23.0518L39.5296 27.72Z",
    fill: "#939598"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4766 18.676L39.5011 18.728L41.4411 18.718L46.0218 11.6357L45.8196 11.3896L39.4766 18.676Z",
    fill: "#F1F2F2"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5092 18.7437L40.3159 20.4557L40.7223 19.8297L39.5092 18.7437Z",
    fill: "#D1D3D4"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3159 20.4561L38.5576 23.1742L37.7693 27.0304L38.7495 27.8204L39.5297 27.7204L41.5432 23.0522L40.3159 20.4561Z",
    fill: "#BCBEC0"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0321 21.5939L36.6481 26.1261L38.5576 23.174L39.4765 18.6758L31.0321 21.5939Z",
    fill: "#D1D3D4"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5875 4.96533L31.0321 21.5941L39.4765 18.676L45.8196 11.3896L40.5875 4.96533Z",
    fill: "#231F20"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27467 22.7681L1.47755 16.9358L-7.03429 14.1797L-6.75043 23.9481L-6.43593 24.0961L3.27467 22.7681Z",
    fill: "#F1F2F2"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0519 0.0450395L28.4794 -1.76904L26.2125 -0.182971L27.0519 0.0450395Z",
    fill: "#E6E7E8"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47755 16.9355L3.27467 22.7678L10.9186 21.7218L1.47755 16.9355Z",
    fill: "#E6E7E8"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4603 1.27898L29.4637 0.694951L27.0519 0.0449219L26.6189 0.594947L27.4603 1.27898Z",
    fill: "#414042"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9662 -2.40918H15.4829L21.0213 2.99507L21.0621 2.98907L21.0724 2.95506L19.4835 -1.99916L17.9662 -2.40918Z",
    fill: "#939598"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4719 1.507L29.8231 0.792969L31.9205 4.96516L32.4719 1.507Z",
    fill: "#D1D3D4"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9185 0.024904L26.6189 0.59493L27.0519 0.044905L26.2125 -0.183105L25.9185 0.024904Z",
    fill: "#414042"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0826 2.98491L21.0621 2.98891L21.0479 3.03491L21.101 3.13491L21.7402 2.9489L25.9185 0.0247712L25.3916 -0.405248L22.3794 -1.21729L21.0724 2.9549L21.0826 2.98491Z",
    fill: "#E6E7E8"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0519 0.0447205L29.4637 0.69475L29.7353 0.614746L28.5223 -1.79736L28.4794 -1.76936L27.0519 0.0447205Z",
    fill: "#F1F2F2"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4718 1.50699L32.7557 -0.26709L29.7353 0.61495L29.8231 0.792958L32.4718 1.50699Z",
    fill: "#A7A9AC"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1138 1.95096L36.5276 -1.36719L32.7557 -0.267138L32.4718 1.50694L34.1138 1.95096Z",
    fill: "#F1F2F2"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1138 1.95086L32.4718 1.50684L31.9205 4.96499L34.1138 1.95086Z",
    fill: "#808285"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0778 46.1551L25.6918 43.0549L25.6836 43.0509L25.6979 43.0489L23.0267 39.2188L7.25491 43.0509L15.4788 46.1551H20.0778Z",
    fill: "#6D6E71"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6461 46.1552L25.702 43.0591L27.4542 46.1552H33.6461Z",
    fill: "#D1D3D4"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7 43.0487L35.9211 41.9507V36.0864L29.139 37.7345L25.7 43.0487Z",
    fill: "#808285"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23448 43.0211L7.2549 43.0511L7.25082 43.0171L7.23448 43.0211Z",
    fill: "#939598"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M29.139 37.7347L35.9211 36.0866L30.6135 35.4546L29.139 37.7347Z",
    fill: "#6D6E71"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4937 34.1504L7.30596 43.0068L7.25082 43.0168L7.25491 43.0508L23.0267 39.2186L19.4937 34.1504Z",
    fill: "#808285"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4542 46.1548L25.702 43.0587L25.6918 43.0547L20.0778 46.1548H27.4542Z",
    fill: "#E6E7E8"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25968 30.9125L3.74234 33.4327L6.06227 33.5307L5.71305 30.7485L5.25968 30.9125Z",
    fill: "#939598"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0763 41.2867L40.7448 36.0864H35.9211V41.9507L42.0763 41.2867Z",
    fill: "#E6E7E8"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4788 46.1549L7.25491 43.0508L9.39717 46.1549H15.4788Z",
    fill: "#414042"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69876 30.6464L5.60481 30.3384L5.48637 30.5344L5.69876 30.6464Z",
    fill: "#939598"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48637 30.5342L5.26989 30.8962L5.69875 30.6462L5.48637 30.5342Z",
    fill: "#A7A9AC"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71305 30.7484L6.31141 30.5324L5.60482 30.3384L5.69876 30.6464L5.71305 30.7484Z",
    fill: "#D1D3D4"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69876 30.6465L5.2699 30.8965L5.25969 30.9125L5.71305 30.7485L5.69876 30.6465Z",
    fill: "#E6E7E8"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5182 34.1325L19.553 34.1085L19.4794 34.1045L19.4774 34.1285L19.5182 34.1325Z",
    fill: "#D1D3D4"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.13776 37.5468L0.376817 33.7486L0.0255632 33.2726L-9.86476 32.8506L-10.8695 35.6587L-6.13776 37.5468Z",
    fill: "#F1F2F2"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.61019 46.1551H-4.45705L-3.36244 45.039L-3.19702 45.007L-3.12759 44.845L2.12696 36.1166L0.376808 33.7485L-6.13777 37.5467L-6.0275 37.5907L-7.61019 46.1551Z",
    fill: "#808285"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12697 36.1167L-3.12759 44.8451L-2.98872 44.9671L7.23448 43.021L2.12697 36.1167Z",
    fill: "#414042"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4937 34.1504L19.5182 34.1324L19.4774 34.1284L19.4937 34.1504Z",
    fill: "#414042"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M1.112 33.3184L0.376808 33.7484L2.12697 36.1165L3.74234 33.4324L1.112 33.3184Z",
    fill: "#414042"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4774 34.1286L19.4794 34.1046L19.3794 34.1006L19.4774 34.1286Z",
    fill: "#939598"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0255547 33.2725L0.376808 33.7485L1.112 33.3185L0.0255547 33.2725Z",
    fill: "#808285"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4937 34.1503L19.4774 34.1283L19.3794 34.1003L6.06226 33.5303L7.25082 43.0167L7.30596 43.0067L19.4937 34.1503Z",
    fill: "#58595B"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6979 43.0508L25.7 43.0488H25.6979V43.0508Z",
    fill: "#6D6E71"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5909 46.1548L45.8155 45.0308L45.6072 44.5288L42.1784 41.2866L37.0137 46.1548H45.5909Z",
    fill: "#F1F2F2"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7447 36.0864H42.0803L39.0497 28.832L38.9476 29.07L40.7447 36.0864Z",
    fill: "#808285"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9476 29.0704L39.0498 28.8324L38.627 27.8184L38.9476 29.0704Z",
    fill: "#A7A9AC"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6461 46.1549H35.9211V41.9507L25.7 43.0487L25.6979 43.0507L25.702 43.0587L33.6461 46.1549Z",
    fill: "#58595B"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6836 43.0508L25.6918 43.0548L25.6979 43.0508V43.0488L25.6836 43.0508Z",
    fill: "#414042"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9211 46.1549H37.0137L43.6671 39.8846L42.0804 36.0864H40.7448L42.0763 41.2867L35.9211 41.9507V46.1549Z",
    fill: "#BCBEC0"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M25.702 43.0588L25.6979 43.0508L25.6918 43.0548L25.702 43.0588Z",
    fill: "#939598"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4908 18.7275L39.5092 18.7435L39.5011 18.7275H39.4908Z",
    fill: "#939598"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5092 18.7438L40.7223 19.8298L41.4411 18.7178L39.5011 18.7278L39.5092 18.7438Z",
    fill: "#6D6E71"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M21.007 3.16309L10.7613 6.15322L13.99 8.37532L20.8886 3.5471L21.007 3.16309Z",
    fill: "#939598"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05816 4.98096L8.94584 6.68303L10.7613 6.15301L9.05816 4.98096Z",
    fill: "#E6E7E8"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0478 3.03512L21.0315 3.00712L21.0213 2.99512L9.06428 4.8712L9.05815 4.98121L10.7613 6.15326L21.007 3.16312L21.0478 3.03512Z",
    fill: "#F1F2F2"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0478 3.03526L21.0621 2.98926L21.0213 2.99526L21.0315 3.00726L21.0478 3.03526Z",
    fill: "#414042"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3794 -1.21699L19.4835 -1.99902L21.0724 2.9552L22.3794 -1.21699Z",
    fill: "#808285"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0724 2.95508L21.0621 2.98908L21.0826 2.98508L21.0724 2.95508Z",
    fill: "#BCBEC0"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8886 3.54721L18.634 10.7375L22.5305 5.78931L21.203 3.3252L20.8886 3.54721Z",
    fill: "#D1D3D4"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5094 11.1394L18.4032 11.4734L18.3215 11.5214L24.0274 24.062L24.1111 24.096L27.6564 15.3176L24.0376 8.59326L18.5094 11.1394Z",
    fill: "#BCBEC0"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5094 11.1393L24.0376 8.59319L22.5305 5.78906L18.634 10.7373L18.5094 11.1393Z",
    fill: "#939598"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23107 17.4719L12.8423 19.3939L17.8722 11.7876L8.23107 17.4719Z",
    fill: "#808285"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03507 16.7455L1.7655 16.9356L8.23107 17.4716L8.42304 14.5854L2.03507 16.7455Z",
    fill: "#58595B"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3215 11.5215L17.8722 11.7875L12.8423 19.3938L24.0274 24.0621L18.3215 11.5215Z",
    fill: "#D1D3D4"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5305 5.78901L24.0376 8.59314L31.8163 5.01298L31.8735 4.87097L27.4603 1.27881L25.6673 1.80283L22.5305 5.78901Z",
    fill: "#6D6E71"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6564 15.3177L31.8163 5.01318L24.0376 8.59335L27.6564 15.3177Z",
    fill: "#6D6E71"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5305 5.7894L25.6673 1.80322L21.7401 2.94928L21.203 3.32529L22.5305 5.7894Z",
    fill: "#939598"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2125 -0.183263L25.3916 -0.405273L25.9185 0.024746L26.2125 -0.183263Z",
    fill: "#6D6E71"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6673 1.80298L26.6189 0.594928L25.9185 0.0249023L21.7401 2.94904L25.6673 1.80298Z",
    fill: "#231F20"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4603 1.27876L26.6189 0.594727L25.6673 1.80278L27.4603 1.27876Z",
    fill: "#808285"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43324 14.4218L17.7354 11.2757L13.7552 8.53955L8.58232 12.1617L8.43324 14.4218Z",
    fill: "#6D6E71"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03507 16.7456L8.08403 12.5094L8.58232 12.1614L8.60479 11.8133L8.94583 6.68311L7.72256 7.04112L1.47755 16.9356L2.03507 16.7456Z",
    fill: "#939598"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7552 8.53943L13.99 8.37542L10.7613 6.15332L8.94584 6.68334L8.6048 11.8136L8.58233 12.1616L13.7552 8.53943Z",
    fill: "#808285"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42303 14.5857L8.43324 14.4217L8.58232 12.1616L8.08403 12.5096L2.03506 16.7458L8.42303 14.5857Z",
    fill: "#A7A9AC"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M18.634 10.7373L18.2092 11.2753L18.5094 11.1393L18.634 10.7373Z",
    fill: "#808285"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5094 11.1396L18.2092 11.2757L18.3215 11.5217L18.4032 11.4737L18.5094 11.1396Z",
    fill: "#D1D3D4"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2092 11.2754L8.42303 14.5855L8.23107 17.4717L17.8722 11.7874L18.2092 11.2754Z",
    fill: "#58595B"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8722 11.7874L18.3215 11.5214L18.2092 11.2754L17.8722 11.7874Z",
    fill: "#231F20"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2092 11.2756L13.99 8.37549L13.7552 8.5395L17.8927 11.3836L18.2092 11.2756Z",
    fill: "#58595B"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M18.634 10.7372L20.8886 3.54688L13.99 8.37509L18.2092 11.2752L18.634 10.7372Z",
    fill: "#A7A9AC"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8927 11.3835L17.6966 11.2495L8.42303 14.4257V14.5857",
    fill: "#939598"
  }))))), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0498 10.2697C35.2023 14.8799 33.9667 12.7818 33.9667 22.0022C33.9667 31.2226 35.2043 29.1245 27.0498 33.7347C18.8974 38.3449 21.3705 38.3449 13.2161 33.7347C5.06364 29.1245 6.29916 31.2226 6.29916 22.0022C6.29916 12.7818 5.06159 14.8799 13.2161 10.2697C21.3685 5.65946 18.8954 5.65946 27.0498 10.2697Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4521 14.2318C34.3057 15.4418 33.9667 17.1639 33.9667 22.0001C33.9667 31.2205 35.2043 29.1224 27.0498 33.7326C22.4427 36.3388 21.2275 37.4708 19.5713 37.1308C18.7177 35.9207 19.0567 34.1987 19.0567 29.3624C19.0567 20.142 17.8191 22.2401 25.9736 17.6299C30.5828 15.0238 31.7959 13.8917 33.4521 14.2318Z",
    fill: "url(#paint1_linear_631_25573)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81379 14.1717C5.96015 15.3818 6.29916 17.1039 6.29916 21.9401C6.29916 31.1605 5.06159 29.0624 13.2161 33.6726C16.7164 35.6507 18.2582 36.7808 19.5223 37.0608C18.73 35.8547 19.0567 34.1066 19.0567 29.3624C19.0567 23.6402 18.5809 22.2781 20.1697 20.964C19.214 20.14 17.4638 19.362 14.2923 17.5679C9.68306 14.9618 8.47 13.8297 6.81379 14.1697",
    fill: "#E2E3EC"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6563 13.5077L20.1452 19.3079L9.51151 13.5117L20.0227 7.71141L30.6563 13.5077ZM32.0205 13.5077L20.0145 6.96338L8.14733 13.5137L20.1534 20.058L32.0205 13.5077ZM24.6605 10.9836C27.2132 12.3756 27.2377 14.6417 24.7136 16.0338C22.1894 17.4259 18.0581 17.4279 15.5053 16.0358C12.9526 14.6437 12.9281 12.3776 15.4522 10.9856C17.9764 9.5935 22.1077 9.5915 24.6605 10.9836ZM25.3385 10.6095C22.4018 9.00947 17.668 9.00947 14.7661 10.6115C11.8641 12.2136 11.8907 14.8097 14.8273 16.4098C17.764 18.0099 22.4978 18.0099 25.3997 16.4078C28.3017 14.8057 28.2751 12.2096 25.3385 10.6095ZM24.0274 15.6618C26.1819 14.4737 26.1615 12.5476 23.9825 11.3596C21.8034 10.1715 18.2909 10.1735 16.1384 11.3596C13.9839 12.5476 14.0043 14.4737 16.1833 15.6618C18.3624 16.8498 21.8749 16.8478 24.0274 15.6618Z",
    fill: "#DDDEE9"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 9.19336H19.6183L16.9226 14.7796H21.3501L22.5509 17.2457H24.007L20.1758 9.19336H20.1738ZM20.7333 13.4916H19.0383L19.892 11.7335L20.7333 13.4916Z",
    fill: "#55217E"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M30.736 21.3481C30.736 21.9421 30.5685 22.5421 30.2377 23.1302C29.9089 23.7142 29.4535 24.2442 28.8858 24.7022C28.4896 25.0202 27.7912 25.4663 26.7517 26.0623L26.4821 26.2163V29.9145L25.0526 30.7325V25.6663L27.5522 24.2362C28.1873 23.8722 28.4998 23.6242 28.6509 23.4802C28.847 23.2922 28.9981 23.0862 29.1104 22.8521C29.2268 22.6121 29.2819 22.3921 29.2819 22.1821C29.2819 21.9721 29.2268 21.8141 29.1104 21.7061C28.9981 21.6021 28.8551 21.5681 28.6734 21.6001C28.5345 21.6261 28.2343 21.7321 27.6053 22.0941L25.0526 23.5562V22.1781L26.9763 21.0761C27.9402 20.524 28.5794 20.2 28.9287 20.086C29.4596 19.912 29.8966 19.928 30.2316 20.132C30.5685 20.34 30.7401 20.748 30.7401 21.3461L30.736 21.3481Z",
    fill: "#55217E"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6408 27.9521C16.6408 28.7241 16.4652 29.3221 16.12 29.7301C15.7708 30.1402 15.3113 30.3402 14.7518 30.3202C14.2004 30.3022 13.4284 30.0242 12.4604 29.4941L9.80763 28.0441V24.3559L11.0881 25.0559V27.496L11.6619 27.8101C12.6544 28.3541 13.3467 28.6741 13.7184 28.7601C14.2188 28.8741 14.6006 28.8061 14.8886 28.5481C15.1765 28.2901 15.3215 27.8501 15.3215 27.238C15.3215 26.594 15.1643 25.954 14.8518 25.3339C14.5414 24.7159 14.1146 24.1859 13.553 23.7119C13.1119 23.3379 12.3665 22.8638 11.3331 22.2978L9.80967 21.4638V20.1997L11.6333 21.1978C12.7913 21.8298 13.6163 22.3738 14.1575 22.8598C14.9315 23.5479 15.5482 24.3539 15.9873 25.2559C16.4223 26.148 16.6428 27.054 16.6428 27.9501L16.6408 27.9521Z",
    fill: "#55217E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_631_25573",
    x1: 45.7257,
    y1: 68.2882,
    x2: 5.87218,
    y2: -6.85839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#69217E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#06624C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_631_25573",
    x1: 27.1214,
    y1: 17.1919,
    x2: 28.2969,
    y2: 33.1963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C2D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDFEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBig);
export default __webpack_public_path__ + "static/media/logoBig.1167f463.svg";
export { ForwardRef as ReactComponent };